<template>
	<label
		class="form-checkbox"
		:class="labelClassObject"
	>
		<div class="form-checkbox__control">
			<input
				:id="id"
				ref="element"
				class="form-checkbox__input"
				type="checkbox"
				data-type="form-checkbox"
				:checked="modelValue"
				:name="name"
				:value="value"
				:required="required"
				:data-look="look"
				@change="changeHandler"
			>
			<div class="form-checkbox__vue">
				<i class="icon icon-check"></i>
			</div>
		</div>
		<slot></slot>
	</label>
</template>

<script>
import { classInstance } from '@/shared/helpers/helpers';
import { useElementChange, useElementComplete } from '@/shared/form/form-element/composition/elementEvents';
import { useGetValid } from '@/shared/form/form-element/form-input/composition/getValid';
import { mapActions } from 'pinia';
import { useInputsStore } from '@/components/order-vue/stores/inputs.js';

export default {
	props: {
		id: { type: String, default: '' },
		name: { type: String, default: '' },
		value: { type: String, default: 'Y' },
		modelValue: { type: Boolean, default: false },
		label: { type: String, default: '' },
		required: { type: Boolean, default: false },
		readonly: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
		look: { type: Boolean, default: false },
		classList: { type: Object, default: () => ({}) },
	},
	emits: ['update:modelValue'],
	data() {
		return {
			valid: false,
			error: false,
		};
	},
	computed: {
		labelClassObject() {
			let classList = {
				valid: this.valid ,
				error: this.error,
				required: this.required,
				readonly: this.readonly,
				disabled: this.disabled
			};
			
			if (this.classList) {
				classList = {
					...classList,
					...this.classList,
				};
			}
			
			return classList;
			
		}
	},
	
	methods: {
		...mapActions(
			useInputsStore,
			{
				addInput: 'add',
				removeInput: 'remove',
				setValid: 'setValid',
			}
		),
		
		validate(options = {}) {
			const optionsValidate = {
				noRender: options.noRender || false,
				noEmpty: options.noEmpty || false,
				rule: 'skip'
			};

			const result = useGetValid(this.$refs.element, optionsValidate);

			if (result.valid && !result.error)
				useElementComplete(this.$refs.element, { checked: this.$refs.element.checked });
			
			if (!optionsValidate.noRender) {
				this.valid = result.valid;
				this.error = result.error;
			}
			
			this.setValid(this.$refs.element, this.$refs.element.checked);
			
			return result.valid;
		},

		changeHandler(event) {
			const isChecked = event.target.checked;
			this.$emit('update:modelValue', isChecked);
			setTimeout(() => useElementChange(this.$refs.element, { checked: isChecked }));
			this.validate();
		},
	},

	mounted() {
		this.addInput(this.$refs.element);
		classInstance.set(this.$refs.element, { formElement: this });
		
		if (this.modelValue) this.validate();
	},
	beforeUnmount() {
		this.removeInput(this.$refs.element);
		classInstance.del(this.$refs.element, 'formElement');
	},
};
</script>
